import moment from 'moment';

/**
 * @typedef {function} Delayer
 * @param {moment.Moment} now The current time to calculate the delay from
 * @return {number} The delay to wait before calculating the next current time
 */

export const onTheMinute = now => (60 - now.seconds()) * 1000 - now.milliseconds();

const utcTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

const vueTime = () => {
  return {
    namespaced: true,
    state: {
      // moments are mutable, so store a string representation
      // so that the vuex state is not modified outside of mutations
      now: moment.utc().format(utcTimeFormat)
    },
    mutations: {
      updateNow(state, now) {
        state.now = now;
      }
    },
    getters: {
      now(state) {
        return moment.utc(state.now);
      },
      localTime(state, getters) {
        // .local() changes the underlying moment, so create a clone
        return getters.now.clone().local();
      },
      time(state, getters) {
        return getters.localTime.format('LT');
      },
      date(state, getters) {
        return getters.localTime.format('L');
      }
    },
    actions: {
      update({commit}) {
        commit('updateNow', moment.utc().format(utcTimeFormat));
      }
    }
  };
};

/**
 * Normalise the interval to a Delayer.
 * @param {*} interval
 * @return {Delayer|boolean} Returns false if we couldn't convert the input
 */
function normaliseInterval(interval) {
  if (typeof interval === 'function') return interval;
  interval = parseInt(interval);
  if (Number.isInteger(interval)) return () => interval;
  return false;
}

/**
 * @param {string|number|Delayer} interval
 * @param {string} moduleName
 * @param {boolean} registerStore
 * @return {function}
 */
export default ({interval = 5000, moduleName = 'time', registerStore = true}) => store => {
  if (registerStore) {
    store.registerModule(moduleName, vueTime());
  }

  if (window.navigator && window.navigator.language) {
    moment.locale(window.navigator.language);
    console.debug('moment locale set to: ', window.navigator.language);
  } else {
    moment.locale('en-gb');
    console.debug('navigator.language not found, moment locale set to: en-gb');
  }

  const delay = normaliseInterval(interval);
  if (delay) {
    function updateAndSchedule() {
      const now = moment.utc();
      store.commit(`${moduleName}/updateNow`, now.format(utcTimeFormat));

      const nextChange = delay(now);
      setTimeout(updateAndSchedule, nextChange);
    }

    updateAndSchedule();
  }
};

export {
  vueTime,
  moment
};
